import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-download-disabled",
  "use": "app-icon-download-disabled-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-download-disabled\"><g stroke=\"#9EA4B3\" stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\"><path stroke-linejoin=\"round\" d=\"M4 6l4 4 4-4\" /><path d=\"M3 13h10\" /><path stroke-linejoin=\"round\" d=\"M8 2v7\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol